module.exports = __webpack_public_path__ + "img/dialog-bg.6080117a.png";